// @givmo/app-admin — onboarding wizard step 2 (optional aggregate company cap).
//
// Ports the Flutter `OnboardingStepTwo`: a checkbox + a whole-dollar money input enabled ONLY when
// the box is checked. Reports `{ isChecked, value }` up to the wizard on every change. Verbatim copy.

import { Checkbox, MaskedInput } from '@givmo/design-system';
import { WHOLE_DOLLAR_MASK, formatWholeDollars, parseWholeDollars } from './onboarding-money';

export interface OnboardingStepTwoProps {
  isChecked: boolean;
  value: number | null;
  onChange: (next: { isChecked: boolean; value: number | null }) => void;
}

export function OnboardingStepTwo({ isChecked, value, onChange }: OnboardingStepTwoProps) {
  return (
    <div className="flex flex-col items-stretch" data-testid="onboarding-step-2">
      <h2 className="font-sans text-s20 font-w700 tracking-givmo text-text-strong">
        Set an aggregate company budget (optional)
      </h2>
      <p className="mt-8 font-sans text-s14 font-w400 leading-h15 tracking-normal text-text-secondary">
        Cap your total annual matching across the whole company. Leave this unchecked to match every
        eligible request up to the per-employee cap.
      </p>

      <div className="mt-32 flex items-center gap-12" data-testid="onboarding-aggregate-toggle">
        <Checkbox
          appearance="saas"
          checked={isChecked}
          onCheckedChange={(checked) => onChange({ isChecked: checked, value })}
          aria-label="Cap total annual company matching"
          testId="onboarding-aggregate-checkbox"
        />
        <span className="font-sans text-s15 font-w500 tracking-normal text-text">
          Cap total annual company matching at:
        </span>
      </div>

      <div className="mt-8">
        <MaskedInput
          imaskOptions={WHOLE_DOLLAR_MASK}
          value={formatWholeDollars(value)}
          placeholder="$0"
          disabled={!isChecked}
          onAccept={(masked) => onChange({ isChecked, value: parseWholeDollars(masked) })}
          aria-label="Aggregate company matching cap"
          testId="onboarding-aggregate-amount"
        />
      </div>
    </div>
  );
}
